import React from "react";
import { Link } from "react-router-dom";
import "./LiftOff.css";
import RichTextContent, { CmsText } from "../../../RichTextContent/RichTextContent";
import { useHomeSection } from "../../../../context/HomePageContext";

import bgShape from "../../../../assets/images/secbg.png";

const LiftOff = () => {
  const { section, loading } = useHomeSection("liftoff");

  if (loading || !section?.fields) return null;

  const fields = section.fields;

  return (
    <section className="liftoff">
      <div className="liftoff-card">
        <img src={bgShape} alt="" className="liftoff-bg" />

        <div className="liftoff-left">
          {fields.title ? (
            <CmsText content={fields.title} as="h2" />
          ) : null}
          {fields.description ? (
            <RichTextContent content={fields.description} />
          ) : null}
        </div>

        <div className="liftoff-right">
          {fields.buttonLink ? (
            <Link to={fields.buttonLink} className="buttonclip liftoff-btn">
              <CmsText content={fields.buttonText} as="span" />
            </Link>
          ) : null}
        </div>
      </div>
    </section>
  );
};

export default LiftOff;
